<template>
    <app-layout class="main">
        <input type="file" id="fileUpload" ref="fileUpload" v-show="false" @change="onFileChange($event)"/>
        <transition name="bounce" mode="out-in">
        <div v-if="material.type === null || (material.type === MATERIAL_TYPE_FILE && material.file === null)" class="row upload-container" key="setType">

            <div class="small-10 medium-4 large-3 column">
                <div class="upload-box drop-target" @drop.prevent="onDrop($event)" @dragover="onDrag($event)" @dragend="onDragEnd($event)">
                    <div><svg-icon :symbol="uploadIcon"></svg-icon></div>
                    <h2>Augšuplādē failus ievelkot tos šeit</h2>
                    <div class="or fancy"><span></span><span>vai</span><span></span></div>
                    <button type="file" class="large success button"
                            @click="onFileUpload($event)">Izvēlies failus no datora</button>
                    <p class="note">Maksimālais faila izmērs 250MB</p>
                </div>
                <div class="supported-types">
                    <svg class="file-type-icon svg-icon icon" v-for="type in fileTypes"><use :xlink:href="'#' + type"></use></svg>
                </div>
            </div>

            <div class="small-10 medium-4 large-3 column" v-if="material.type === null">
                <div class="upload-box">
                    <div><svg-icon :symbol="uploadIcon"></svg-icon></div>
                    <h2>Pievieno saiti uz video vai mācību materiāliem</h2>
                    <button class="large success button" @click="material.type = MATERIAL_TYPE_LINK">Pievienot saiti</button>
                </div>
                <div class="supported-types">
                    <svg-icon v-for="type in linkTypes" :key="type.id" :symbol="type" :originalDims="true" class="link-type-icon svg-icon icon"></svg-icon>
                </div>
            </div>

        </div>

        <div v-else class="row upload-container" key="setData">

            <panel v-if="material.id == null" key="materialForm">
                <h2 slot="header">{{ panelTitle }}</h2>

                <div class="panel-content">
                    <material-form :material.sync="material" ref="materialForm"></material-form>
                </div>

                <div slot="footer" style="width:100%;">
                    <button class="button hollow secondary float-left" @click="reset()" type="button">Atpakaļ</button>
                    <button class="button success float-right" type="button" @click.prevent="submitMaterial()" :disabled="errors.any()">Iesniegt</button>
                </div>
            </panel>

            <panel v-else key="materialResult">
                <h2 slot="header">{{ panelTitle }}</h2>

                <div class="text-center">
                    <svg-icon :symbol="successIcon" style="width: 150px; height:150px;"></svg-icon>
                    <h1>Apsveicam!<br/>Jūsu materiāls ir iesniegts.</h1>
                    <p>Failu varat apskatīt šeit:</p>
                    <material-item :material="material" v-if="material.id !== null" class="uploaded-material"></material-item>
                </div>

                <div slot="footer" style="text-align: center; width: 100%;">
                    <a href="#" @click.prevent="reset()" class="button success">Uz sākumu</a>
                </div>
            </panel>

        </div>
        </transition>
    </app-layout>
</template>

<script>
    import AppLayout from '../layouts/AppLayout'
    import MaterialItem from '../components/MaterialItem'
    import SvgIcon from '../components/SvgIcon'
    import MaterialForm from '../components/materials/MaterialForm'
    import Panel from '../components/Panel'

    import uploadIcon from '../../icons/icon-upload.svg-sprite'
    import successIcon from '../../icons/icon-success.svg-sprite'
    import videoIcon from '../../../assets/icons/icon-movie.svg-sprite'
    import linkIcon from '../../../assets/icons/icon-link.svg-sprite'

    const MATERIAL_TYPE_FILE = 'file';
    const MATERIAL_TYPE_LINK = 'link';

    function materialModel() {
        return {
            id: null,
            title: null,
            uri: null,
            type: null,
            mime_type: null,
            description: null,
            signature_type: null,
            categories: [],
            file: null,
        }
    }

    export default {

        props: {
            categories: {
                type: Array,
                default: function () {
                    return [];
                }
            },
            type: {
                type: String,
                required: false,
            }
        },

        data() {
            return {
                MATERIAL_TYPE_FILE,
                MATERIAL_TYPE_LINK,
                uploadIcon,
                successIcon,

                material: materialModel(),

                fileTypes: ['excel', 'pdf', 'word', 'powerpoint', 'image'],
                linkTypes: [videoIcon, linkIcon]
            }
        },

        computed: {
            panelTitle() {
                return this.material.type === MATERIAL_TYPE_LINK ? 'Pievienot saiti' : 'Augšuplādēt failu';
            },
        },

        methods: {
            onFileChange(e) {
                console.log('file input changed', e.target.files[0]);
                this.material.file = e.target.files[0];
            },

            onDrop(ev) {
                // If dropped items aren't files, reject them
                const dt = ev.dataTransfer;

                if (dt.items) {
                    // Use DataTransferItemList interface to access the file(s)
                    for (let i = 0; i < dt.items.length; i++) {
                        if (dt.items[i].kind === "file") {
                            let f = dt.items[i].getAsFile();
                            console.log("... file[" + i + "].name = " + f.name);
                            this.material.file = f;
                            break;
                        }
                    }
                } else {
                    // Use DataTransfer interface to access the file(s)
                    this.material.file = dt.files[0];
//                    for (let i = 0; i < dt.files.length; i++) {
//                        console.log("... file[" + i + "].name = " + dt.files[i].name);
//                    }
                }
            },

            onDrag(ev) {
                console.log("dragOver");
                // Prevent default select and drag behavior
                ev.preventDefault();
            },

            onDragEnd(ev) {
                console.log("dragEnd");
                // Remove all of the drag data
                let dt = ev.dataTransfer;
                if (dt.items) {
                    // Use DataTransferItemList interface to remove the drag data
                    for (let i = 0; i < dt.items.length; i++) {
                        dt.items.remove(i);
                    }
                } else {
                    // Use DataTransfer interface to remove the drag data
                    ev.dataTransfer.clearData();
                }
            },

            /**
             * Open file upload panel
             */
            onFileUpload(ev) {
                this.$el.querySelector('#fileUpload').click();
            },

            reset() {
                console.log('resetting');
                this.material = materialModel.apply(this);
                //Object.assign(this.$data, this.$options.data.apply(this));
                this.errors.clear();
                this.$refs.fileUpload.value = null;
            },

            // Call material form submit handler directly
            submitMaterial(e) {
                this.$refs.materialForm.save();
            },
        },

        created() {
            this.material.categories = this.categories;
            if (this.type) {
                this.material.type = this.type;
            }
            console.log('upload created ', this.material);
        },

        destroyed() {
            console.log('upload destroyed');
        },

        watch: {

            'categories': function (val, oldVal) {
                console.log('Upload.categories changed');
                this.materials.categories = this.categories;
            },

            'material.file': function (val, oldVal) {
                console.log('material.file change', val);

                if (typeof val !== 'undefined' && val !== null) {
                    this.material.type          = val ? MATERIAL_TYPE_FILE : null;
                    this.material.mime_type     = val ? val.type : null;
                }
            },

            'type': function (val, oldVal) {
                console.log('type changed in upload', val)
                this.material.type = val;
            }
        },

        components: {
            SvgIcon, MaterialItem, AppLayout, MaterialForm, Panel
        }
    }
</script>

<style lang="scss" scoped>
    @import "../../sass/settings";
    @import "../../sass/mixins";
    @import "../../sass/foundation/config";

    .main {
        background-color: #f0f0f0;
    }

    /* TODO duplicate */
    .upload-container {
        justify-content: center;
        vertical-align: middle;
        padding: rem-calc(100px) 0;

        .column {
            margin-bottom: rem-calc(50px);
        }
    }

    .supported-types {
        text-align: center;
        height: 45px;
        margin-top: 15px;

        .file-type-icon {
            width: 40px;
            height: 45px;
        }

        .icon:not(:last-of-type) {
            margin-right: 5px;
        }
    }

    .uploaded-material {
        max-width: 240px;
        margin-left: auto;
        margin-right: auto;
    }

    .upload-box {
        display: flex;
        flex-flow: row wrap;
        text-align: center;
        padding: rem-calc(54px) rem-calc(28px);
        border: 3px solid #cccccc;
        min-height: rem-calc(350px);
        cursor: pointer;
        position: relative;


        &:hover {
            background-color: white;
        }

        &.drop-target {
            border-style: dashed;
        }

        > * {
            width: 100%;
        }

        h2 {
            font-size: px-em(22px);
        }

        .icon {
            width: 46px;
            height: 29px;
        }

        .button {
            align-self: flex-end;
            margin-bottom: 0;
            font-size: 15px;
            font-weight: 700;
        }

        .or {
            font-style: italic;
        }

        .note {
            position: absolute;
            bottom: 0;
            left: 0;
            right: 0;
        }
    }
</style>


// WEBPACK FOOTER //
// resources/assets/js/views/Upload.vue